<template>
  <form @submit.prevent="handleSubmit(item)">
    <b-row>
      <b-col>
        <template>
          <b-row>
            <b-col>
              <label>{{$t("views.exsbinvoices.form.correctionState")}}:</label>
              <model-select :isDisabled="item.accepted === 1" v-model="correctionState" :options="decisionOptions" name="invoicesOptions" id="correctionState" :placeholder="$t('global.select')">
              </model-select>
              <section v-if="correctionState === 1 || item.invoiceCorrectionOf">
                <label>{{$t("views.exsbinvoices.form.correctionComment")}}:</label>
                <input :disabled="correctionState === 0 && !item.invoiceCorrectionOf" v-model="item.correctionComment" name="correctionComment" type="text" autofocus :placeholder="$t('views.exsbinvoices.form.correctionComment')" class="form-control" id="correctionComment"/>
              </section>
              <section v-if="correctionState === 1 || item.invoiceCorrectionOf">
                <label>{{$t("views.exsbinvoices.form.correctionOf")}}:</label>
                <BaseSelectInput
                  ref="invoiceCorrectionOf"
                  v-model="item.invoiceCorrectionOf"
                  :search-callback="invoiceSearchCallback"
                  :get-processed-text-custom="getInvoiceProcessedText"
                  :display-values="['number', 'buyerName']"
                  :query-param="'invoiceAutoCompleteFilter'"
                  :placeholder-autocomplete="'Zacznij wpisywać numer lub odbiorcę faktury'"
                  :is-auto-complete-mode="true"
                  :disabled="item.accepted === 1"
                ></BaseSelectInput>
              </section>
              <label>{{$t("global.type")}}:</label>
              <model-select :isDisabled="item.id > 0 && (correctionState === 1 || item.accepted === 1)" v-model="item.invoiceType" :options="invoiceTypes" name="type" id="type" :placeholder="$t('global.type')">
              </model-select>
              <section v-if="item.invoiceType !== 11">
                <label>{{$t("views.exsbinvoices.form.number")}}:</label>
                <input :disabled="item.batchNumber > 0" v-model="item.number" name="ownNumber" type="text" autofocus :placeholder="$t('views.exsbinvoices.form.ownNumber')" class="form-control" id="ownNumber"/>
              </section>
              <section v-if="invoiceType < 9">
                <label>{{$t("views.exsbinvoices.form.batchNumber")}}:</label>
                <model-select :isDisabled="item.accepted === 1" v-model="item.batchNumber" :options="batchNumbersOptions" name="batchNumber" id="batchNumber" :placeholder="$t('views.exsbinvoices.form.batchNumber')">
                </model-select>
              </section>
            </b-col>
            <b-col>
              <label for="issuePlace">{{$t("views.exsbinvoices.form.issuePlace")}}:</label>
              <input v-model="item.issuePlace"
                     :disabled="disableForReceipt === 1 && invoiceType !== 3" name="issuePlace" type="text" autofocus :placeholder="$t('views.exsbinvoices.form.issuePlace')" class="form-control" id="issuePlace"/>
              <div class="form-group">
                <label
                  for="exsbinvoice_issueDate"
                  class="form-control-label">{{$t('views.exsbinvoices.form.issueDate')}}:</label>
                <fg-input :error="violations.issueDate">
                  <el-date-picker
                    :picker-options="{firstDayOfWeek: 1}"
                    placement="bottom-start"
                    v-model="item.issueDate"
                    :disabled="(disableForReceipt === 1 || Boolean(item['@id'])) && invoiceType !== 3"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd">
                  </el-date-picker>
                </fg-input>
                <div
                  v-if="isInvalid('issueDate')"
                  class="invalid-feedback">{{ violations.issueDate }}</div>
              </div>
              <div class="form-group">
                <label
                  for="exsbinvoice_sellDate"
                  class="form-control-label">{{$t('views.exsbinvoices.form.sellDate')}}:</label>
                <fg-input :error="violations.sellDate">
                  <el-date-picker
                    :picker-options="{firstDayOfWeek: 1}"
                    placement="bottom-start"
                    v-model="item.sellDate"
                    :disabled="disableForReceipt === 1 && invoiceType !== 3"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd">
                  </el-date-picker>
                </fg-input>
                <div
                  v-if="isInvalid('sellDate')"
                  class="invalid-feedback">{{ violations.sellDate }}</div>
              </div>
              <label>{{$t("views.exsbinvoices.form.paymentWay")}}:</label>
              <model-select v-model="item.paymentWay" :options="paymentWayOptions" name="paymentWay" id="paymentWay" :placeholder="$t('views.exsbinvoices.form.paymentWay')">
              </model-select>
              <div class="form-group">
                <label
                  for="exsbinvoice_paymentDeadline"
                  class="form-control-label">{{$t('views.exsbinvoices.form.paymentDeadline')}}:</label>
                <fg-input :error="violations.paymentDeadline">
                  <el-date-picker
                    placement="bottom-start"
                    v-model="item.paymentDeadline"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions">
                  </el-date-picker>
                </fg-input>
                <div
                  v-if="isInvalid('paymentDeadline')"
                  class="invalid-feedback">{{ violations.paymentDeadline }}</div>
              </div>
            </b-col>
            <b-col>
              <label>{{$t("views.exsbinvoices.form.setBuyerData")}}:</label>
              <b-row>
                <b-col>
                  <b-btn class="btn btn-success" @click="showModal('buyerDataModal')"><i class="fas fa-user-edit mr-2"></i>{{ $t('views.exsbinvoices.form.setBuyerData') }}</b-btn><br>
                </b-col>
                <b-col>
                  <b-btn v-if="ableToUpdateUserData" class="btn btn-block btn-success" @click="showCreateContractorModal()"><i class="fas fa-user-edit mr-2"></i>{{ $t('menu.contractors.create') }}</b-btn>
                </b-col>
              </b-row>
              <label for="buyerName">{{$t("global.idName")}}:</label>
              <input disabled v-model="item.buyerName" name="buyerName" type="text" autofocus :placeholder="$t('global.idName')" class="form-control" id="buyerName"/>
              <b-row>
                <b-col cols="6">
                  <label for="buyerStreet">{{$t("global.street")}}:</label>
                  <input disabled v-model="item.buyerStreet" name="buyerStreet" type="text" autofocus :placeholder="$t('global.street')" class="form-control" id="buyerStreet"/>
                </b-col>
                <b-col>
                  <label for="buyerStreetNumber">{{$t("global.buyerStreetNumberShort")}}:</label>
                  <input disabled v-model="item.buyerStreetNumber" name="buyerStreetNumber" type="text" class="form-control" id="buyerStreetNumber"/>
                </b-col>
                <b-col>
                  <label for="buyerPlaceNumber">{{$t("global.buyerLocalNumberShort")}}:</label>
                  <input disabled v-model="item.buyerPlaceNumber" name="buyerPlaceNumber" type="text" class="form-control" id="buyerPlaceNumber"/>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <label for="buyerCity">{{$t("views.exsbinvoices.form.buyerCity")}}:</label>
                  <input disabled v-model="item.buyerCity" name="buyerCity" type="text" class="form-control" id="buyerCity"/>
                </b-col>
                <b-col>
                  <label for="buyerPostcode">{{$t("views.exsbinvoices.form.buyerPostcode")}}:</label>
                  <input disabled v-model="item.buyerPostcode" name="buyerPostcode" type="text" class="form-control" id="buyerPostcode"/>
                </b-col>
              </b-row>
              <section v-if="invoiceType === 1 || invoiceType === 2 || invoiceType === 3" class="mt-2">
                <div class="form-group">
                  <label
                    for="exsbinvoice_firm"
                    class="form-control-label">{{$t('views.exsbinvoices.form.idUserData')}}:</label>
                  <model-select :isDisabled="true" v-b-tooltip.hover :title="$t('views.exsbinvoices.form.idUserDataTooltip')" v-model="item.idUserData" :options="userDataOptions" name="paymentWay" id="paymentWay" :placeholder="$t('views.exsbinvoices.form.idUserData')">
                  </model-select>
                  <p>{{ $t('views.exsbinvoices.form.idUserDataEmail') }}:</p>
                  <ul>
                    <li v-for="(invoiceRecipient, index) in userDataOptions" v-show="invoiceRecipient.vatInvoiceRecipient === 1" :key="'invoiceRecipient'+index">
                      {{ invoiceRecipient.text }}
                    </li>
                  </ul>
                  <div
                    v-if="isInvalid('idUserData')"
                    class="invalid-feedback">{{ violations.idUserData }}</div>
                </div>
              </section>
            </b-col>
          </b-row>
          <b-row v-if="!loadingAgreements && agreementOptions.length > 1 && item.idUserData">
            <b-col v-if="!item.idAgreement">
              <b-alert class="mt-3" show variant="primary">{{$t('views.exsbinvoices.form.idAgreementInfo')}}</b-alert>
            </b-col>
            <b-col>
              <div class="form-group">
                <label>{{$t("tableHeadings.agreement")}}:</label>
                <model-select v-model="item.idAgreement" name="idAgreement" :isDisabled="item.accepted === 1" :options="agreementOptions" :placeholder="$t('tableHeadings.agreement')" class="">
                </model-select>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <!--            invoice_document_type-->
            <b-col>
              <div class="form-group">
                <label
                  for="exsbinvoice_invoice_document_type"
                  class="form-control-label">{{$t('views.exsbinvoices.form.documentType')}}:</label>
                <fg-input :error="violations.invoiceDocumentType">
                  <el-select
                    id="exsbinvoice_invoice_document_type"
                    :class="['select-default', isInvalid('invoiceDocumentType') ? 'select-danger' : '']"
                    :placeholder="$t('views.exsbinvoices.form.documentType')"
                    :disabled="hasId"
                    filterable
                    v-model="item.invoiceDocumentType">
                    <el-option v-for="option in documentTypeOptions"
                               class="select-default"
                               :value="option.value"
                               :label="$t(option.text)"
                               :key="option.value">
                    </el-option>
                  </el-select>
                </fg-input>
                <div
                  v-if="isInvalid('invoiceDocumentType')"
                  class="invalid-feedback">{{ violations.invoiceDocumentType }}</div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="4" v-for="item in apps" :key="item['@id']">
              <h5 class="mb-0">
                <b-badge variant="info text-left">
                  <p class="m-0">{{item.subdomain}}.{{item.domain.domain}}</p>
                  <p class="m-0">{{$t('views.exsbinvoices.form.quantityActiveAgreements')}}{{item.externalData.activeAgreements[0].activeAgreements}}</p>
                  <p class="m-0">{{$t('views.exsbinvoices.form.quantityActiveStudents')}}{{item.externalData.activeGroupUserdata[0].activeUsersInGroup}}</p>
                </b-badge>
              </h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <h6 class="mt-3 mb-1">{{ $t('views.exsbinvoices.form.sellerData') }}:</h6>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="form-group">
                <label
                  for="exsbinvoice_sellerNip"
                  class="form-control-label">{{$t('views.exsbinvoices.form.sellerNip')}}:</label>
                <input
                  id="exsbinvoice_sellerNip"
                  v-model="item.sellerNip"
                  :disabled="hasId"
                  :class="['form-control', isInvalid('sellerNip') ? 'is-invalid' : '']"
                  type="text"
                  placeholder=""
                  @input="handleUpdateField('sellerNip', $event.target.value)">
                <div
                  v-if="isInvalid('sellerNip')"
                  class="invalid-feedback">{{ violations.sellerNip }}</div>
              </div>
            </b-col>
            <b-col>
              <div class="form-group">
                <label
                  for="exsbinvoice_sellerName"
                  class="form-control-label">{{$t('views.exsbinvoices.form.sellerName')}}:</label>
                <input
                  id="exsbinvoice_sellerName"
                  v-model="item.sellerName"
                  :disabled="hasId"
                  :class="['form-control', isInvalid('sellerName') ? 'is-invalid' : '']"
                  type="text"
                  required="true"
                  placeholder=""
                  @input="handleUpdateField('sellerName', $event.target.value)">
                <div
                  v-if="isInvalid('sellerName')"
                  class="invalid-feedback">{{ violations.sellerName }}</div>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="form-group">
                <label
                  for="exsbinvoice_sellerStreet"
                  class="form-control-label">{{$t('views.exsbinvoices.form.sellerStreet')}}:</label>
                <input
                  id="exsbinvoice_sellerStreet"
                  v-model="item.sellerStreet"
                  :disabled="hasId"
                  :class="['form-control', isInvalid('sellerStreet') ? 'is-invalid' : '']"
                  type="text"
                  required="true"
                  placeholder=""
                  @input="handleUpdateField('sellerStreet', $event.target.value)">
                <div
                  v-if="isInvalid('sellerStreet')"
                  class="invalid-feedback">{{ violations.sellerStreet }}</div>
              </div>
            </b-col>
            <b-col>
              <div class="form-group">
                <label
                  for="exsbinvoice_sellerStreetNumber"
                  class="form-control-label">{{$t('views.exsbinvoices.form.sellerStreetNumber')}}:</label>
                <input
                  id="exsbinvoice_sellerStreetNumber"
                  v-model="item.sellerStreetNumber"
                  :disabled="hasId"
                  :class="['form-control', isInvalid('sellerStreetNumber') ? 'is-invalid' : '']"
                  type="text"
                  required="true"
                  placeholder=""
                  @input="handleUpdateField('sellerStreetNumber', $event.target.value)">
                <div
                  v-if="isInvalid('sellerStreetNumber')"
                  class="invalid-feedback">{{ violations.sellerStreetNumber }}</div>
              </div>
            </b-col>
            <b-col>
              <div class="form-group">
                <label
                  for="exsbinvoice_sellerPlaceNumber"
                  class="form-control-label">{{$t('views.exsbinvoices.form.sellerPlaceNumber')}}:</label>
                <input
                  id="exsbinvoice_sellerPlaceNumber"
                  v-model="item.sellerPlaceNumber"
                  :disabled="hasId"
                  :class="['form-control', isInvalid('sellerPlaceNumber') ? 'is-invalid' : '']"
                  type="text"
                  required="true"
                  placeholder=""
                  @input="handleUpdateField('sellerPlaceNumber', $event.target.value)">
                <div
                  v-if="isInvalid('sellerPlaceNumber')"
                  class="invalid-feedback">{{ violations.sellerPlaceNumber }}</div>
              </div>
            </b-col>
            <b-col>
              <div class="form-group">
                <label
                  for="exsbinvoice_sellerCity"
                  class="form-control-label">{{$t('views.exsbinvoices.form.sellerCity')}}:</label>
                <input
                  id="exsbinvoice_sellerCity"
                  v-model="item.sellerCity"
                  :disabled="hasId"
                  :class="['form-control', isInvalid('sellerCity') ? 'is-invalid' : '']"
                  type="text"
                  required="true"
                  placeholder=""
                  @input="handleUpdateField('sellerCity', $event.target.value)">
                <div
                  v-if="isInvalid('sellerCity')"
                  class="invalid-feedback">{{ violations.sellerCity }}</div>
              </div>
            </b-col>
            <b-col>
              <div class="form-group">
                <label
                  for="exsbinvoice_sellerPostcode"
                  class="form-control-label">{{$t('views.exsbinvoices.form.sellerPostcode')}}:</label>
                <input
                  id="exsbinvoice_sellerPostcode"
                  v-model="item.sellerPostcode"
                  :disabled="hasId"
                  :class="['form-control', isInvalid('sellerPostcode') ? 'is-invalid' : '']"
                  type="text"
                  required="true"
                  placeholder=""
                  @input="handleUpdateField('sellerPostcode', $event.target.value)">
                <div
                  v-if="isInvalid('sellerPostcode')"
                  class="invalid-feedback">{{ violations.sellerPostcode }}</div>
              </div>
            </b-col>
          </b-row>
        </template>
        <invoice-positions :item="item"></invoice-positions>
        <template>
          <b-row>
            <b-col>
              <div class="form-group">
                <label
                  for="exsbinvoice_invoiceStatus"
                  class="form-control-label">{{$t('views.exsbinvoices.form.invoiceStatus')}}:</label>
                <fg-input :error="violations.invoiceStatus">
                  <el-select
                    id="exsbbatchnumber_invoiceStatus"
                    :class="['select-default', isInvalid('invoiceStatus') ? 'select-danger' : '']"
                    :placeholder="$t('views.exsbinvoices.form.invoiceStatus')"
                    filterable
                    v-model="item.invoiceStatus">
                    <el-option v-for="option in invoiceStatuses"
                               class="select-default"
                               :value="option['@id']"
                               :label="option.name"
                               :key="option['@id']">
                    </el-option>
                  </el-select>
                </fg-input>
                <div
                  v-if="isInvalid('invoiceStatus')"
                  class="invalid-feedback">{{ violations.invoiceStatus }}</div>
              </div>
            </b-col>
            <b-col>
              <label for="toPay">{{$t("views.exsbinvoices.form.toPay")}}:</label>
              <input :disabled="invoiceStatus !== 3" v-model="item.toPay" name="toPay" type="text" :placeholder="$t('views.exsbinvoices.form.toPay')" class="form-control" id="toPay"/>
            </b-col>
            <b-col>
              <label for="paid">{{$t("views.exsbinvoices.form.paid")}}:</label>
              <input :disabled="invoiceStatus !== 3" v-model="item.paid" name="paid" type="text" :placeholder="$t('views.exsbinvoices.form.paid')" class="form-control" id="paid"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <div class="form-group">
                <label
                  for="exsbinvoice_paymentWay"
                  class="form-control-label">{{$t('views.exsbinvoices.form.paymentWay')}}:</label>
                <fg-input :error="violations.paymentWay">
                  <el-select
                    id="exsbbatchnumber_paymentWay"
                    :class="['select-default', isInvalid('paymentWay') ? 'select-danger' : '']"
                    :placeholder="$t('views.exsbinvoices.form.paymentWay')"
                    filterable
                    v-model="item.paymentWay">
                    <el-option v-for="option in paymentWays"
                               class="select-default"
                               :value="option['@id']"
                               :label="option.name"
                               :key="option['@id']">
                    </el-option>
                  </el-select>
                </fg-input>
                <div
                  v-if="isInvalid('paymentWay')"
                  class="invalid-feedback">{{ violations.paymentWay }}</div>
              </div>
            </b-col>
            <b-col>
            </b-col>
          </b-row>
        </template>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-form-group>
          <label for="sellerAccount">{{ $t('views.exsbinvoices.form.accountNumber') }}:</label>
          <input type="text" id="sellerAccount" v-model="item.sellerAccount" class="form-control" />
        </b-form-group>
      </b-col>
    </b-row>
    <template>
      <div class="form-group">
        <label
          for="exsbinvoice_comments"
          class="form-control-label">{{$t('views.exsbinvoices.form.comments')}}:</label>
        <input
          id="exsbinvoice_comments"
          v-model="item.comments"
          :class="['form-control', isInvalid('comments') ? 'is-invalid' : '']"
          type="text"
          placeholder=""
          @input="handleUpdateField('comments', $event.target.value)">
        <div
          v-if="isInvalid('comments')"
          class="invalid-feedback">{{ violations.comments }}</div>
      </div>
      <div>
        <b-button id="show-btn" variant="success" @click="onSubmit">{{$t('buttons.submit')}}</b-button>
        <b-modal id="buyerDataModal" ref="buyerDataModal" hide-footer>
          <div slot="modal-header" class="w-100">
            <h5 class="modal-title float-left">
              {{$t('views.exsbinvoices.form.buyerDataModalHeader')}}
            </h5>
            <button type="button" aria-label="Close" class="close" @click="hideModal('buyerDataModal')">
              ×
            </button>
          </div>
          <b-row>
            <b-col>
              <label>{{$t('views.exsbinvoices.form.buyerUserData')}}</label>
              <base-select-input
                class="w-100"
                v-model="buyerUserData"
                :search-callback="buyerSearchCallback"
                :display-values="['fullName', 'firmname1']"
                :query-param="'userdata'"
                :is-auto-complete-mode="$store.getters['configuration/enableAutoCompleteForUserData']"
              ></base-select-input>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col>
              <b-btn class="btn btn-success" @click="appendUserDataToBuyerData(buyerUserData)">{{ $t('buttons.select') }}</b-btn>
              <b-btn class="btn btn-danger" @click="hideModal('buyerDataModal')">{{ $t('buttons.cancel') }}</b-btn>
            </b-col>
          </b-row>
          <div slot="modal-footer" class="w-100"></div>
        </b-modal>
        <b-modal ref="modalToCreateInvoice" hide-footer>
          <div slot="modal-header" class="w-100">
            <h6 class="modal-title m-0 float-left">
              {{$t('views.exsbinvoices.modal.modalHeader')}}
            </h6>
            <button type="button" aria-label="Close" class="close" @click="hideModalToCreateInvoice()">
              ×
            </button>
          </div>
          <b-row>
            <b-col>
              <b-form-checkbox
                id="acceptThoseInvoices"
                name="acceptThoseInvoices"
                v-model="item.acceptThoseInvoices"
                :value="true"
                :unchecked-value="false"
                class="float-left"
              >
                <p class="mt-1">{{$t('views.exsbinvoices.modal.acceptThoseInvoices')}}</p>
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-checkbox
                id="prepareMailWithInvoice"
                name="prepareMailWithInvoice"
                v-model="item.prepareMailWithInvoice"
                :value="1"
                :unchecked-value="0"
                class="float-left"
              >
                <p class="mt-1">{{$t('views.exsbinvoices.modal.prepareMailWithInvoice')}}</p>
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col>
              <button @click="handleSubmit(item)" class="btn btn-primary">{{ $t('buttons.submit') }}</button>
              <b-btn v-if="editType && editType === 'data'" @click="closeModalForData" variant="danger">{{ $t('buttons.close') }}</b-btn>
            </b-col>
          </b-row>
        </b-modal>
        <create-contractor-modal></create-contractor-modal>
      </div>
    </template>
  </form>
</template>

<script>
// import Position from './components/Position'
import InvoicePositions from '@/components/Dashboard/Views/BusinessBundle/exsbinvoice/components/InvoicePositions'
import currencyFieldConverter from '@/utils/currencyFieldConverter'
import { checkPermission } from '@/utils/checkRoles'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import ApiService from '@/utils/ApiService'
import getId from '@/utils/getIdFromLink'
import { ModelSelect } from 'vue-search-select'
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput'
import CreateContractorModal from '@/components/Dashboard/Views/firm/modals/CreateModal'

export default {
  components: {
    BaseSelectInput,
    ModelSelect,
    InvoicePositions,
    CreateContractorModal
  },
  props: {
    idFirm: {
      type: String,
      required: false
    },

    editType: {
      type: String,
      required: true
    },

    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    ...mapGetters({
      documentTypeOptions: 'exsbinvoice/list/documentTypeOptions',
      invoiceStatuses: 'exsbinvoice/list/invoiceStatusOptions',
      batchNumbers: 'exsbinvoice/list/batchNumberOptions',
      paymentWays: 'exsbinvoice/list/paymentWayOptions',
      invoiceTypes: 'exsbinvoice/list/invoiceTypeOptions',
      itemsArray: 'exsbinvoice/list/itemOptions',
      createdItem: 'exsbitem/create/created',
      createdContractor: 'userdata/create/created'
    }),
    ableToUpdateUserData () {
      return checkPermission('firms', 'FirmCreate')
    },
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },
    violations () {
      return {}
    },
    invoiceType () {
      return parseInt(this.getIdLink(this.item.invoiceType))
    },
    invoiceStatus () {
      return parseInt(this.getIdLink(this.item.invoiceStatus))
    },
    hasId () {
      return !!(this.item && this.item['@id'])
    },
    batchNumbersOptions () {
      let array = []
      array.push({ value: null, text: this.$t('views.exsbinvoices.form.noBatchNumber') })
      if (this.batchNumbers && this.batchNumbers.length > 0) {
        this.batchNumbers.forEach((entry) => {
          if (entry.documentsAllowed.includes(this.item.invoiceType)) {
            array.push({ value: entry.value, text: entry.text })
          }
        })
      }
      return array
    },
    paymentWayOptions () {
      return this.paymentWays.map(entry => {
        return {
          text: entry.name,
          value: entry['@id']
        }
      })
    }
  },
  data () {
    return {
      apps: [],
      agreementOptions: [],
      loadingAgreements: true,
      issueDate: this.$moment().format('YYYY-MM-DD'),
      sellDate: this.$moment().format('YYYY-MM-DD'),
      prepareMailWithInvoice: false,
      pickerOptions: {
        firstDayOfWeek: 1,
        shortcuts: [
          {
            text: '7 dni',
            onClick (picker) {
              let date = new Date()
              picker.$emit('pick', new Date(date.setTime(date.getTime() + 7 * 86400000)))
            }
          },
          {
            text: '10 Dni',
            onClick (picker) {
              let date = new Date()
              picker.$emit('pick', new Date(date.setTime(date.getTime() + 10 * 86400000)))
            }
          },
          {
            text: '2 tygodnie',
            onClick (picker) {
              let date = new Date()
              picker.$emit('pick', new Date(date.setTime(date.getTime() + 14 * 86400000)))
            }
          },
          {
            text: '1 miesiąc',
            onClick (picker) {
              let date = new Date()
              picker.$emit('pick', new Date(date.setMonth(date.getMonth() + 1)))
            }
          }
        ]
      },
      baseParams: {
        'pagination': false
      },
      routeName: '',
      batchNumberByTypeOptions: [],
      userDataOptions: [],
      buyerUserData: null,
      showSpinner: false,
      correctionState: 0,
      disableForReceipt: 0,
      addingNewPosition: 0,
      decisionOptions: [
        { value: 0, text: this.$t('buttons.no') },
        { value: 1, text: this.$t('buttons.yes') }
      ]
    }
  },
  created () {
    if (!this.item['@id']) {
      this.item.issueDate = this.$moment().format('YYYY-MM-DD')
      this.item.sellDate = this.$moment().format('YYYY-MM-DD')
    }
    this.routeName = this.$route.name
    if (this.idFirm) {
      this.appendUserDataToBuyerData(this.idFirm)
    } else if (this.item.idUserData) {
      this.appendUserDataToBuyerData(this.item.idUserData, true)
    }
    // fetch lists
    this.fetchInvoiceStatusOptions()
    this.fetchBatchNumberOptions()
    this.fetchPaymentWayOptions()
    this.fetchVatRateOptions()
    this.fetchInvoiceTypeOptions()
    this.fetchItemOptions()
    this.fetchMeasureOptions()
  },
  watch: {
    createdItem (val) {
      if (val) {
        this.fetchItemOptions()
      }
    },
    'invoiceType' (val) {
      this.recalculatePaid(this.item.totalValueBrutto)
      this.fetchBatchNumberOptions()
    },
    'item.totalValueNetto': function (val) {
      this.recalculatePaid(this.item.totalValueBrutto)
    },
    'item.invoiceStatus': function (val) {
      this.recalculatePaid(this.item.totalValueBrutto)
    },
    createdContractor: {
      handler (val) {
        if (val) {
          this.appendUserDataToBuyerData(val['@id'])
        }
      }
    }
  },
  methods: {
    ...mapMutations({
      toggleItemCreateModal: 'exsbitem/createModal/toggleModal',
      showCreateContractorModal: 'userdata/createModal/toggleModal'
    }),
    ...mapActions({
      fetchInvoiceStatusOptions: 'exsbinvoice/list/fetchInvoiceStatusOptions',
      fetchBatchNumberOptions: 'exsbinvoice/list/fetchBatchNumberOptions',
      fetchPaymentWayOptions: 'exsbinvoice/list/fetchPaymentWayOptions',
      fetchVatRateOptions: 'exsbinvoice/list/fetchVatRateOptions',
      fetchInvoiceTypeOptions: 'exsbinvoice/list/fetchInvoiceTypeOptions',
      fetchItemOptions: 'exsbinvoice/list/fetchItemOptions',
      fetchMeasureOptions: 'exsbinvoice/list/fetchMeasureOptions'
    }),
    onSubmit () {
      if (this.item['@id'] === undefined || this.item['@id'] === null) {
        this.openModalToCreateInvoice()
      } else {
        this.handleSubmit(this.item)
      }
    },
    openModalToCreateInvoice () {
      this.$refs['modalToCreateInvoice'].show()
    },
    hideModalToCreateInvoice () {
      this.$refs['modalToCreateInvoice'].hide()
    },
    async appendUserDataToBuyerData (idFirm, withoutUpdate = false) { // fetch all data to table
      this.userDataOptions = []
      this.userData = await new ApiService(idFirm).getResults()
      if (!withoutUpdate) {
        this.item.idUserData = this.userData['@id']
        this.item.buyerNip = this.userData.nip
        this.item.buyerPostcode = this.userData.postcode
        this.item.buyerName = this.userData.fullName + this.userData.firmname1
        this.item.buyerCity = this.userData.city
        this.item.buyerStreet = this.userData.street
        this.item.buyerStreetNumber = this.userData.streetNumber
        this.item.buyerPlaceNumber = this.userData.placeNumber
      }
      let array = []
      array.push({ text: (this.userData.fullName + this.userData.firmname1) + ' (' + (this.userData.userEmail || this.userData.contactEmail) + ')', value: this.userData['@id'] })
      this.userData.userDataEmployees.forEach(function (entry) {
        array.push({ text: (entry.employee.fullName + entry.employee.firmname1) + ' (' + (entry.employee.userEmail || entry.employee.contactEmail) + ')', value: entry.employee['@id'], vatInvoiceRecipient: entry.vatInvoiceRecipient })
      })
      this.userDataOptions = array
      this.fetchAgreementOptions(this.item.idUserData)
      this.hideModal('buyerDataModal')
    },
    showModal (modal) {
      this.$refs[modal].show()
    },
    hideModal (modal) {
      this.$refs[modal].hide()
    },
    putInvoiceAccepted () {
      let data = { sellDate: this.sellDate }
      return new ApiService(`e_x_s_b_invoices/${getId(this.$route.params.id)}/accept`).put(data)
    },
    fillSellerData (seller) {
      if (seller) {
        this.item.sellerNip = seller.nip
        this.item.sellerName = seller.firmname1
        this.item.sellerStreet = seller.street
        this.item.sellerCity = seller.city
        this.item.sellerPostcode = seller.postcode
        this.item.sellerStreetNumber = seller.streetNumber
        this.item.sellerPlaceNumber = seller.placeNumber
      }
    },
    async fillBuyerData (buyerId) {
      if (buyerId) {
        this.userData = await new ApiService(buyerId).getResults()
        this.item.idUserData = this.userData['@id']
        this.item.buyerNip = this.userData.nip
        this.item.buyerPostcode = this.userData.postcode
        this.item.buyerName = this.userData.fullName + this.userData.firmname1
        this.item.buyerCity = this.userData.city
        this.item.buyerStreet = this.userData.street
        this.item.buyerStreetNumber = this.userData.streetNumber
        this.item.buyerPlaceNumber = this.userData.placeNumber
      }
    },
    closeModalForData () {
      this.$store.state.modals.exsbinvoices.update.dataUpdateClose = 1
    },

    closeModalForPositions () {
      this.$store.state.modals.exsbinvoices.update.positionsUpdateClose = 1
    },
    recalculatePaid (val) {
      if (this.invoiceStatus === 1) {
        this.item.toPay = val
        this.item.paid = 0
      } else if (this.invoiceStatus === 2) {
        this.item.paid = val
        this.item.toPay = 0
      }
    },
    getCurrencyValue (netto, maxDecimalPlaces, minus) {
      return currencyFieldConverter(netto, maxDecimalPlaces, minus)
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    },
    async buyerSearchCallback (params = {}) {
      let baseParams = { pagination: false }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    },
    async fetchAgreementOptions (idUserData) {
      this.loadingAgreements = true
      let params = { pagination: false, idClient: idUserData }
      const response = await new ApiService('e_x_a_b_agreements', params).getResults()
      this.agreementOptions = response.items.map(item => {
        return { value: item['@id'],
          text: (item.idClient.firmname1 === '' ? item.idClient.fullName : item.idClient.firmname1) + ' (' + (item.number || this.$t('views.agreements.list.noNumber')) + ')' + (item.applicationName ? ' (' + item.applicationName + ')' : '')
        }
      })
      this.agreementOptions.unshift({ text: this.$t('global.notSet'), value: null })
      this.loadingAgreements = false
    },
    async invoiceSearchCallback (params = {}) {
      let baseParams = { pagination: false, accepted: 1 }
      Object.assign(baseParams, params)
      const response = await new ApiService('e_x_s_b_invoices', baseParams).getResults()
      return response.items
    },
    getInvoiceProcessedText (entry) {
      let textData = entry.buyerName + ' / '
      if (entry.nip) {
        textData += entry.nip + ' / '
      }
      textData += entry.number + ' (' + this.$t('views.exsbinvoices.show.toPay') + ': ' + entry.toPay + ' / ' +
        this.$t('views.exsbinvoices.form.invoiceValue') + ': ' + entry.totalValueBrutto + ')'
      return textData
    },
    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
